<template>
  <div class="users">
    <div class="list pane">
      <input
        type="text"
        class="user-search"
        v-model="search"
        placeholder="Search..."
        @input="searchUsers" />
      <div v-for="user of filteredUsers" class="user-item" :key="user.id">
        <router-link :to="{ path: `/users/${user.id}` }">
          {{ user.name }}
        </router-link>
        <div class="role-icons">
          <span
            v-for="role in userRoles(user)"
            :key="role"
            :class="['role', role]"
            :title="role">
            <i :class="['icon', roleIcon(role)]"></i></span>
        </div>
      </div>
    </div>
    <div class="details" :class="{ loading: isLoading }" v-if="user">
      <User :user="user" :transactions="editUserTrx" />
      <EditUser :user="user" />
      <Submissions :submissions="editUserSubmissions" />
      <Transactions v-if="isAdmin" :transactions="editUserTrx" />
    </div>
    <div class="leaderboards" v-else>
      <div class="details">
        <h3>The Wealthy</h3>
        <div class="list">
          <div v-for="(user, idx) of usersWealthy" :key="user.twitchId">
            {{ idx + 1 }}.
            <router-link
              :to="{ path: `/users/${user.id}` }"
              v-text="user.name" />
            <br />
            <small>Balance: {{ user.balance }}</small>
          </div>
        </div>
      </div>
      <div class="details">
        <h3>The Thrifty</h3>
        <div class="list">
          <div v-for="(user, idx) of usersThrifty" :key="user.twitchId">
            {{ idx + 1}}.
            <router-link
              :to="{ path: `/users/${user.id}` }"
              v-text="user.name" />
            <br />
            <small>Spent: {{ Math.abs(user.spent) }}</small>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import debounce from 'debounce'
import ApiHelper from '../mixins/ApiHelper'
import User from './User.vue'
import EditUser from './EditUser.vue'
import Transactions from './Transactions.vue'
import Submissions from './Submissions.vue'

export default {
  name: 'Users',
  props: ['id'],
  mixins: [ApiHelper],

  components: {
    User,
    EditUser,
    Transactions,
    Submissions
  },

  data () {
    return {
      search: ''
    }
  },

  computed: {
    ...mapState([
      'users',
      'usersRich',
      'usersSpenders',
      'usersSearch',
      'editUser',
      'editUserTrx',
      'editUserSubmissions',
      'isLoading'
    ]),
    ...mapGetters(['isAdmin']),

    usersWealthy () {
      return this.usersRich
        .filter((u) => u.twitchId !== '43349612')
        .slice(0, 10)
    },
    usersThrifty () {
      return this.usersSpenders
        .filter((u) => u.twitchId !== '43349612')
        .slice(0, 10)
    },

    filteredUsers () {
      if (this.search.length === 0) {
        return this.users
      }

      return this.usersSearch

      // const query = this.search.toLowerCase()
      //   .split(' ')
      //   .map((part) => part.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))
      //   .join('|')

      // const rexp = new RegExp(query)
      // return this.users.filter((user) => user.name.toLowerCase().match(rexp))
    },

    user () {
      if (this.id) {
        return this.editUser
        // this.$store.dispatch('editUser', this.id)
        return this.$store.getters.getUser(this.id)
      }
      return false
    }
  },

  methods: {
    fetchSupplements () {
      if (this.id) {
        this.$store.dispatch('editUser', this.id)
      }
    },

    userRoles (user) {
      const flags = Object.entries(user.flags)
        .filter(([ flag, pos ]) => pos)
        .map(([ flag ]) => flag)
      return flags
    },

    roleIcon (role) {
      switch (role) {
        case 'admin': return 'fas fa-crown'
        case 'moderator': return 'fas fa-gavel'
        case 'trusted': return 'fas fa-thumbs-up'
        case 'banned': return 'fas fa-skull-crossbones'
        default: return 'fas fa-question'
      }
    },

    searchUsers: debounce(async function () {
      this.$store.dispatch('searchUsers', this.search)
    }, 500)
  },

  watch: {
    '$route': 'fetchSupplements'
  },

  created () {
    this.fetchSupplements()
  }
}
</script>

<style scoped>
.users {
  display: flex;
}

.user-search {
  background: #00000014;
  width: 100%;
  border: 0;
  font: inherit;
  padding: 1em;
  border-bottom: inherit;
}

.user-item {
  margin: 1em;
  clear: both;
}

.list {
  flex-shrink: 0;
}

.details {
  margin-left: 1em;
  flex-grow: 1;
  transition: opacity 150ms ease-out;
}
.details.loading {
  opacity: 0.5;
  cursor: wait;
}

.details > * + * {
  margin-top: 1em;
}

.transactions {
  max-height: 400px;
  overflow-y: auto;
}

.submissions {
  max-height: 600px;
  overflow-y: auto;
}

.role-icons {
  float: right;
  font-size: 0.85em;
}
.role-icons .role {
  padding: 0;
}

.leaderboards {
  display: flex;
  width: 100%;
}
</style>
